import CloseIcon from 'svg/CloseIcon';
import { ButtonText } from 'components/Button';
import Modal from 'components/modals/Modal';
import OverallStats from './OverallStats';
import ReviewListing from './ReviewListing';
import { ReviewsOverviewModalProps } from '../../types';

const ReviewsOverviewModal: React.FC<ReviewsOverviewModalProps> = ({
  open,
  handleClose,
  reviews,
}) => {
  return (
    <Modal
      isOpen={open}
      handleClose={handleClose}
      classNameMaxWidth="max-w-[95vw]"
      className="md:h-[95dvh]"
    >
      <div className="flex h-full w-full flex-col  bg-color-bg-lightmode-primary  dark:bg-color-bg-darkmode-primary">
        <div className="flex justify-end px-[4rem] py-ds-2xl max-md:px-4">
          <ButtonText onClick={handleClose}>
            <CloseIcon className="h-5 w-5" />
          </ButtonText>
        </div>
        <div className="container relative mx-auto  mt-6 flex min-h-0 flex-1 gap-12 px-ds-2xl max-md:flex-col max-sm:px-4">
          <OverallStats reviews={reviews} />
          <ReviewListing reviews={reviews} />
        </div>
      </div>
    </Modal>
  );
};

export default ReviewsOverviewModal;
